/**
 * Created by stonewang on 2017/8/15.
 */
import React from 'react';

class homeSet extends React.Component {
  render() {
    return <div className='dms-body'>
      {this.props.children}
    </div>
  }
};
export default homeSet;


// WEBPACK FOOTER //
// ./src/routes/homeSet/index.js